var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncouragmentMonday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 58,
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_55115)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.2679,
    cy: 42.8147,
    r: 42.0179,
    fill: "url(#paint0_linear_82_55115)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_82_55115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5148 46.7742C32.0241 46.4496 31.6227 46.2477 31.2173 46.0166C30.9737 45.8778 30.8561 45.5906 30.9283 45.3197L31.9677 41.4186C32.0395 41.1549 32.1274 40.8956 32.2308 40.6426C32.4317 40.151 32.6169 39.6785 33.015 39.3094L33.5453 38.8177C33.7761 38.6035 33.7636 38.2418 33.5291 38.0316C33.3793 37.8975 33.3171 37.6912 33.3703 37.4978L33.4955 37.0424C33.6787 36.3761 33.4048 35.6521 32.8018 35.3146C32.0526 34.8954 31.1094 35.1969 30.74 35.9666L28.0246 43.7712C27.9565 43.9669 27.8837 44.161 27.8012 44.3514C27.5825 44.8564 27.0623 46.4355 28.2587 47.9897C28.9591 49.0005 29.2783 49.0021 33.2291 51.6149L34.2978 47.9683L32.5148 46.7742Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4667 49.7969H39.1035C39.428 51.5216 40.7288 53.1115 42.2851 53.1115C43.8415 53.1116 45.1422 51.5216 45.4667 49.7969Z",
    fill: "#F3EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5562 39.3092C51.9542 39.6784 52.1395 40.1508 52.3404 40.6424C52.4438 40.8955 52.5317 41.1547 52.6035 41.4184L53.6429 45.3196C53.7151 45.5905 53.5975 45.8776 53.3538 46.0164C53.2966 46.049 53.2394 46.081 53.1821 46.1129C53.116 46.4516 53.0084 47.3563 53.5492 48.0677C53.9323 48.5717 54.5561 48.865 55.4055 48.9441C55.8154 48.6339 56.0342 48.3914 56.3126 47.9897C57.509 46.4355 56.9887 44.8564 56.7701 44.3513C56.6876 44.1611 56.6149 43.9669 56.5467 43.7711L53.8314 35.9665C53.4619 35.1969 52.5187 34.8954 51.7696 35.3147C51.1665 35.6522 50.8928 36.376 51.0759 37.0423L51.2011 37.4977C51.2543 37.6912 51.192 37.8974 51.0422 38.0316C50.8076 38.2417 50.7951 38.6035 51.026 38.8176L51.5562 39.3092Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3539 46.0156C52.9485 46.2467 52.5472 46.4486 52.0564 46.7732L50.2734 47.9674L51.3423 51.6141C53.9537 49.887 54.9781 49.3009 55.5751 48.8101C52.6267 48.6343 53.3539 46.0156 53.3539 46.0156Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.429 21.3267L46.4878 20.6087C46.0943 20.5515 45.7541 20.3043 45.5781 19.9479L43.3684 15.4703C42.9252 14.5724 41.6448 14.5724 41.2017 15.4703L38.9919 19.9479C38.9499 20.0329 38.898 20.1113 38.8389 20.1828C38.8397 20.7415 38.9402 22.1194 39.8445 23.0116C40.4439 23.6032 41.2802 23.8634 42.3319 23.7864L45.4236 27.6382C45.4199 27.8946 45.4568 28.9141 46.2295 29.6254C46.7793 30.1314 47.5689 30.3583 48.5809 30.3046L48.1757 27.942C48.1085 27.5501 48.2384 27.1502 48.5231 26.8727L52.0986 23.3874C52.8155 22.6883 52.4199 21.4706 51.429 21.3267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0824 20.6101L33.1411 21.328C32.1502 21.4721 31.7546 22.6897 32.4716 23.3887L36.0471 26.8739C36.3319 27.1515 36.4617 27.5514 36.3946 27.9433L35.5504 32.8646C35.3812 33.8516 36.417 34.6041 37.3033 34.1382L41.7229 31.8146C42.0748 31.6296 42.4952 31.6296 42.8472 31.8146L47.2668 34.1382C48.1532 34.6041 49.189 33.8516 49.0197 32.8646L48.556 30.161C45.4019 30.318 45.5717 27.59 45.5717 27.59L42.3974 23.6354C38.6903 23.9636 38.9918 19.9492 38.9918 19.9492C38.8159 20.3058 38.4758 20.5529 38.0824 20.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7676 44.1872C46.7676 46.9406 44.7609 49.8664 42.2856 49.8664C39.8104 49.8664 37.8037 46.9407 37.8037 44.1872C37.8037 41.4338 39.8104 39.6641 42.2856 39.6641C44.7609 39.664 46.7676 41.4337 46.7676 44.1872Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2113 40.8693C66.2113 33.8247 63.1663 27.4917 58.3212 23.1133C55.9747 24.7636 53.3882 27.9208 56.1879 33.0566C60.6801 41.2974 64.4421 47.5701 58.0201 51.6115C52.8911 54.8392 50.4292 59.1787 52.5048 62.5059C60.6062 58.6731 66.2113 50.4269 66.2113 40.8693Z",
    fill: "#F5AFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 40.8693C18.3594 33.8247 21.4044 27.4917 26.2495 23.1133C28.596 24.7636 31.1825 27.9208 28.3828 33.0566C23.8906 41.2974 20.1286 47.5701 26.5507 51.6115C31.6797 54.8392 34.1416 59.1787 32.066 62.5059C23.9645 58.6731 18.3594 50.4269 18.3594 40.8693Z",
    fill: "#F5AFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2728 47.9648L47.288 49.6385C47.1055 49.7408 46.8997 49.7945 46.6905 49.7945H45.312C44.9912 51.398 43.7819 52.9604 42.285 52.9604C42.1698 52.9604 42.0566 52.9501 41.9452 52.9322C41.5481 53.3604 41.1974 54.0099 41.1974 54.9692L41.1976 63.5557C41.197 63.5668 41.1772 64.1584 41.6007 64.7853C41.828 64.7917 42.0561 64.7953 42.2851 64.7953C44.0539 64.7953 45.7773 64.6017 47.4368 64.2374L47.2949 54.8601C47.2865 54.2639 47.6042 53.711 48.1238 53.4187C48.8115 53.0317 49.8266 52.4605 51.3416 51.6115C51.5261 50.9027 51.5493 49.6204 50.2728 47.9648Z",
    fill: "#E9C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2755 54.86L37.1336 64.2373C38.6332 64.5664 40.1853 64.7547 41.7757 64.7883C41.3146 64.1678 41.3441 63.563 41.3441 63.563C41.3441 63.563 41.3441 57.0852 41.3441 54.9692C41.3441 53.9924 41.7188 53.3561 42.1222 52.9535C40.7011 52.8453 39.5674 51.3394 39.2584 49.7945H37.8798C37.6711 49.7945 37.4652 49.741 37.2824 49.6385L34.2975 47.9648C33.0212 49.6203 33.0443 50.9027 33.2288 51.6115C34.7438 52.4604 35.7589 53.0316 36.4466 53.4186C36.9663 53.7109 37.2839 54.2637 37.2755 54.86Z",
    fill: "#EBA5B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_55115",
    x1: 42.2679,
    y1: 0.796875,
    x2: 42.2679,
    y2: 77.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_55115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.0357,
    height: 56.5625,
    fill: "white",
    transform: "translate(0.25 0.796875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_82_55115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(17.2852 14.7969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncouragmentMonday);
export default __webpack_public_path__ + "static/media/encouragment-monday.301afc5b55a905e41bab64579645e163.svg";
export { ForwardRef as ReactComponent };